import SSSlideDisplayer from './00-slideshare_slide_displayer'
import SSDocumentSlider from './00-slideshare_document_slider'

function SSDocumentDisplayer(config) {
  if (typeof config === "undefined") {
    return;
  }
  SSSlideDisplayer.call(this, config);
  this.zoomLevels = [1, 1.2, 1.5, 1.75, 2, 2.5, 3, 4];
  this.prerenderedSlides = [];
  this.isMobile = this.config.hosted_in === "mobile_slideview";
}

SSDocumentDisplayer.prototype = new SSSlideDisplayer();

SSDocumentDisplayer.prototype._bindEvents = function () {
  var that = this;
  var i, slide;
  var container = this.container;
  var linksDisabled = this.config.linksDisabled;

  var didScroll = false;
  if (this.config.show_image_player) {
    container.scroll(function (e) {
      didScroll = true;
    });

    setInterval(function () {
      if (didScroll) {
        didScroll = false;
        var currentSlide = that.detectCurrentSlide();
        if (!that.scrolledToBottom(currentSlide)) {
          $.slideshareEventManager.trigger("slidescrolled", {
            index: currentSlide,
            alreadyInPosition: true,
          });
        } else {
          $.slideshareEventManager.trigger("showlastscreen");
        }
      }
    }, 100);
  } else {
    if (!this.isMobile && !this.documentSlider) {
      container.unbind("scroll");
      container.bind("scroll", function (e) {
        var currentSlide = that.detectCurrentSlide();
        $.slideshareEventManager.trigger("slidescrolled", {
          index: currentSlide,
          alreadyInPosition: true,
        });
      });
    }
  }

  //Binding click on links in documents (same as in band interaction)
  container.unbind("click");
  container.bind("click", function (e) {
    var target = e.target;
    var targetTagName = target.tagName.toUpperCase();
    var targetNode;
    if (linksDisabled) {
      targetNode = false; // working around jslint. This line shouldn't be needed
    } else if (
      targetTagName === "SPAN" &&
      target.parentNode.tagName.toUpperCase() === "A"
    ) {
      // new conversion changes, anchor tags have a child span tag
      targetNode = target.parentNode;
    } else if (targetTagName === "A" || targetTagName === "AREA") {
      targetNode = target;
    }
    // old conversion structure, anchor tags had no child span tag
    if (targetNode) {
      var hrefValue = parseInt(targetNode.attributes.href.value, 10);
      if (isNaN(hrefValue)) {
        window.open(targetNode.href);
      }
      $.slideshareEventManager.trackOutboundClick(targetNode);
    }
  });

  $(container).bind("click", function (e) {
    e.preventDefault();
  });
};

SSDocumentDisplayer.prototype._scrollTo = function (index) {
  if (this.config.show_image_player) {
    var slide = this.slidesContainer.children(".slide").eq(index - 1);
    this.container.first().scrollTop(slide.position().top);
  } else {
    if (this.slides) {
      if (this.documentSlider) {
        if (!this.documentSlider.inner) {
          this.documentSlider._initInner();
        }
        if (this.slideOffsets[index] !== undefined) {
          var slideEdge = this.slideOffsets[index];
          this.documentSlider.inner.css("top", -slideEdge);
          if (!this.isMobile) {
            var thumbYPosition =
              ((this.documentSlider.scrollbarY.height() -
                this.documentSlider.thumbY.height()) *
                slideEdge) /
              (this.documentSlider.inner.height() -
                this.documentSlider.viewHeight);

            this.documentSlider.thumbY.css("top", thumbYPosition);
          }
        }
      } else {
        var topOffset =
          this.slides[index].currentViewMode.container.position().top;
        this.container.scrollTop(topOffset);
      }
    }
  }
};

SSDocumentDisplayer.prototype.start = function (config) {
  var i, slide;
  this.lastScrollTop = 0;

  if (this.slideContainers === undefined) {
    this.slideContainers = [];
  }

  var slideContainers = this.slideContainers;

  if (!this.config.show_image_player) {
    // Are native scrollbars visible?
    // If not, we shouldn't use the SSDocumentSlider.
    // The assumption is, if window.screen.width == $(document).width(),
    // then the browser will not get native scrollbars and SSDocumentSlider is not needed.
    var nativeScrollbarsVisible = window.screen.width !== $(document).width();

    // Only load the new slider when IE 9 or greater, or if not IE
    var IE9PlusOrNotIE =
      typeof document.documentMode === "undefined" ||
      document.documentMode >= 9;

    // Only initialize the docslider once per pageload.
    // Once somebody zooms, quit using the doc slider.
    if (typeof this.hadADocSliderAlready === "undefined") {
      this.hadADocSliderAlready = false;
    }

    if (this.documentSlider) {
      this.documentSlider.cleanup();
      delete this.documentSlider;
      // Only display the new scrollbar on the slideview page (not in slideshelf or embeds)
    } else if (
      this.isMobile ||
      (!this.hadADocSliderAlready &&
        config.mode !== "nativefullscreen" &&
        nativeScrollbarsVisible &&
        IE9PlusOrNotIE &&
        this.config.hosted_in === "slideview")
    ) {
      this.documentSlider = new SSDocumentSlider({
        dDisplayer: this,
      });
      this.hadADocSliderAlready = true;
    }
  }

  if (this.slides === undefined) {
    this.slides = config.slides;
    this.state = "playing";
    this.hideInitializer();

    if (this.config.show_image_player) {
      this.slidesContainer = $(".slide_container");
      this.$slides = this.slidesContainer.children(".slide");
    } else {
      this.slidesContainer = $("<div/>").appendTo(this.container);
    }

    for (i = 1; i <= this.config.slideCount; i++) {
      if (this.config.show_image_player) {
        slideContainers[i] = $(".slide").eq(i - 1);
      } else {
        slideContainers[i] = $("<div/>").appendTo(this.slidesContainer);
      }
    }
  }

  if (!this.config.show_image_player) {
    this.slidesContainer
      .removeClass(this.playerBgColor)
      .addClass("slidesContainer " + config.playerBgColor);
  }

  if (config.playerBgColor) {
    this.playerBgColor = config.playerBgColor;
  }

  for (i = 1; i <= this.config.slideCount; i++) {
    slide = this.slides[i];
    slide.setContainer({
      mode: config.mode,
      bgColor: this.playerBgColor,
      container: slideContainers[i],
      slideNumber: i,
    });
  }
};

SSDocumentDisplayer.prototype.showInitializer = function () {
  if (!this.config.show_image_player) {
    $("<div/>")
      .addClass(".jsplInitializer")
      .css({
        width: this.container.width() - 10,
        height: this.container.height() - 20,
      })
      .html("Loading...")
      .appendTo(this.container);
  }
};

SSDocumentDisplayer.prototype.detectCurrentSlide = function () {
  var that = this;

  if (this.config.show_image_player) {
    // Get current slide index
    var slideContainer = this.container;
    var scrollTop = slideContainer.scrollTop();

    if (
      typeof this.lastScrollTop === "undefined" ||
      typeof this.lastSlideIndex === "undefined"
    ) {
      this.lastScrollTop = -1;
      this.lastSlideIndex = -1;
    }

    var lastSlideIndex = this.currentPosition;
    var currentSlideIndex, slides;

    if (scrollTop > this.lastScrollTop) {
      var sliceStart = lastSlideIndex - 3 < 0 ? 0 : lastSlideIndex - 3;
      slides = this.$slides.slice(sliceStart);
    } else {
      // up
      slides = $(
        this.$slides
          .slice(0, lastSlideIndex + 3)
          .get()
          .reverse()
      );
    }

    slides.each(function () {
      var realTopOffset = $(this).position().top - scrollTop;
      if (
        realTopOffset <= slideContainer.height() / 2 &&
        realTopOffset + $(this).height() > slideContainer.height() / 2
      ) {
        currentSlideIndex = $(this).data("index");
        return false;
      }
    });

    that.lastScrollTop = scrollTop;

    this.lastSlideIndex = currentSlideIndex;
    return currentSlideIndex;
  } else {
    var viewHeight = this.height;
    var viewEdge1 = this.documentSlider
      ? this.documentSlider.topEdge()
      : this.container.scrollTop();
    var currentSlide = (function () {
      var i;
      for (i = 1; i < that.config.slideCount; i++) {
        var slideEdge1 = that.slideOffsets[i];
        var slideEdge2 = that.slideOffsets[i + 1];
        if (viewEdge1 >= slideEdge1 && viewEdge1 < slideEdge2) {
          return i;
        }
      }
      return that.config.slideCount;
    })();

    return currentSlide;
  }
};

SSDocumentDisplayer.prototype.scrolledToBottom = function (currentSlideIndex) {
  if (!this.config.slideCount || this.config.slideCount !== currentSlideIndex) {
    return false;
  }
  var scrollTop = this.container.scrollTop();
  var currentSlide = this.slides[currentSlideIndex].$slide;
  var realTopOffset = currentSlide.position().top - scrollTop;
  if (realTopOffset + currentSlide.height() <= this.container.height()) {
    return true;
  }
  return false;
};

SSDocumentDisplayer.prototype.setZoom = function (index) {
  this.zoomIndex = index;
  var currentZoom = this.zoomLevels[this.zoomIndex];
  var zoomWidth;

  if (this.config.show_image_player) {
    var currentScrollTop = this.container.scrollTop();
    var currentSlide = this.detectCurrentSlide();

    this._scrollTo(currentSlide);
    var refScrollTop = this.container.scrollTop();

    if (currentZoom === 1) {
      this.container
        .removeClass("jsplDocumentZoomed")
        .addClass("jsplDocumentUnZoomed");
      this.slidesContainer.width("100%");
      this.width = this.slidesContainer.width();
    } else {
      this.container
        .removeClass("jsplDocumentUnZoomed")
        .addClass("jsplDocumentZoomed");
      zoomWidth = this.config.width * currentZoom;
      this.slidesContainer.width(zoomWidth);
      this.width = zoomWidth;
    }

    // Preserve scroll position
    this._scrollTo(currentSlide);
    this.container.scrollTop(
      (currentScrollTop * this.container.scrollTop()) / refScrollTop
    );
  } else {
    if (currentZoom === 1) {
      this.container
        .removeClass("jsplDocumentZoomed")
        .addClass("jsplDocumentUnZoomed");
      this.slidesContainer.width("100%");
      this.width = this.slidesContainer.width();
    } else {
      this.container
        .removeClass("jsplDocumentUnZoomed")
        .addClass("jsplDocumentZoomed");
      zoomWidth = this.config.width * currentZoom;
      this.slidesContainer.width(zoomWidth);
      this.width = zoomWidth;
    }
    if (this.documentSlider) {
      this.documentSlider.drawThumbs();
    }
  }
};

SSDocumentDisplayer.prototype.getZoomDimensions = function () {
  var currentZoom = this.zoomLevels[this.zoomIndex];
  return {
    width: this.config.width * currentZoom,
    height: this.config.height * currentZoom,
    displayerWidth: this.width,
  };
};

SSDocumentDisplayer.prototype.setDimensions = function (dimensions) {
  var that = this;

  if (this.config.show_image_player) {
    if (typeof dimensions === "object") {
      this.config.width = dimensions.width;
      this.config.height = dimensions.height;
    }
  } else {
    if (typeof dimensions === "object") {
      this.config.width = dimensions.width;
      this.config.height = dimensions.height;
    }
    var partialUpdate = dimensions && dimensions.partial;
    if (!partialUpdate && this.state === "playing") {
      this.setZoom(this.zoomIndex);
    }
    var zoomDimensions = this.getZoomDimensions();
    var zoomWidth = zoomDimensions.width;
    var zoomHeight = zoomDimensions.height;
    var slidesContainerWidth = zoomDimensions.displayerWidth;

    // we want the container to take up only allowed slideheight. However, it should scale to fit available width
    // so that the scrollbars are at the edge. This appies only for documents
    this.container.css({
      height: this.config.height,
      width: this.config.width,
    });

    if (!partialUpdate && this.state === "playing") {
      this.panelHeight = 0;
      var i, slide, offset;
      offset = 0;
      for (i = 1; i <= this.config.slideCount; i++) {
        slide = this.slides[i];
        slide.setDimensions({
          parentWidth: slidesContainerWidth,
          parentHeight: zoomHeight,
        });
        this.slideOffsets[i] = offset;
        offset += slide.wrapperOffset();
      }

      //caching size values from jQuery for detectCurrentSlide optimizations
      this.height = offset;

      if (!this.isMobile && this.documentSlider) {
        this.documentSlider.drawThumbs();
        this.documentSlider.makeThumbsDraggable();
        this.documentSlider.makeScrollbarsClickable();
      }
      if (this.isMobile) {
        $(".slideShow").height(slide.currentViewMode.height);
      }
    }
  }
};

SSDocumentDisplayer.prototype.setPrerenderedSlides = function (config) {
  if (!this.config.show_image_player) {
    var i;
    for (i = config.start; i <= config.end; i++) {
      if ($.inArray(i, this.prerenderedSlides) === -1) {
        this.prerenderedSlides.push(i);
      }
    }
  }
};

SSDocumentDisplayer.prototype.emptySlides = function () {
  if (!this.config.show_image_player) {
    var i;
    for (i in this.slides) {
      var slides = this.slides;
      if (slides.hasOwnProperty(i)) {
        var slide = slides[i];
        slide.hide();
      }
    }
    this.prerenderedSlides = [];
  }
};

SSDocumentDisplayer.prototype.manualScroll = function (delta) {
  this.container &&
    this.container.scrollTop(this.container.scrollTop() + delta);
};

export default SSDocumentDisplayer;
